import { reduxField } from "../../../reduxHelpers";

const { reducer, actions, saga } = reduxField.HR.WORKING_TYPE();
export { reducer, actions, saga };
